import { render, staticRenderFns } from "./VideoPage.vue?vue&type=template&id=2fd322b2&scoped=true&"
import script from "./VideoPage.vue?vue&type=script&lang=js&"
export * from "./VideoPage.vue?vue&type=script&lang=js&"
import style0 from "./VideoPage.vue?vue&type=style&index=0&id=2fd322b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd322b2",
  null
  
)

export default component.exports